module.exports = __webpack_public_path__ + "laserove-beleni-zubu_4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/special/laserove-beleni-zubu_4.jpg
// module id = 912
// module chunks = 0